import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-tag-blocklist',
		path: '/admin/blocklisted_tags',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_tag_blocklist" */ './index'), {
			exportName: 'BlocklistedTags',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
